module.exports = __webpack_public_path__ + "images/img-2H7IBCK.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/managers/90.jpg
// module id = 2017
// module chunks = 0